export const ErrorCode = {
  ERROR_CONNECTION_EXPIRED: 'AUTH004',
};
